export default __webpack_public_path__ + "static/media/Honggil_crop_resize.3dcef564.png";